import { Box } from '@mui/material';
import { Clickthrough } from '../Pager/Clickthrough';
import { PagerProvider } from '../Pager/PagerProvider';

const MobileGuide = () => {
  return (
    <Box sx={{ backgroundColor: '#ECECEC', padding: '16px' }}>
      <PagerProvider>
        <Clickthrough />
      </PagerProvider>
    </Box>
  );
};

export { MobileGuide };
